import { DatePipe } from "@angular/common";
import { AfterViewInit, Component, Input } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { AvatarComponent } from "@ponder-shared/components/avatar.component";
import { MarkdownBlockComponent } from "@ponder-shared/components/markdown/markdown-block.component";

@Component({
    selector: "news-post",
    imports: [AvatarComponent, DatePipe, MarkdownBlockComponent],
    templateUrl: "./news-post.component.html"
})
export class NewsPostComponent implements AfterViewInit {
    @Input({ required: true }) title!: string;
    @Input({ required: true }) content!: string;
    @Input({ required: true }) authorUsername!: string;
    @Input() authorDisplayName?: string;
    @Input({ required: true }) createdAt!: Date;
    @Input() modifiedAt?: Date;
    @Input() id?: string;
    @Input() truncated?: boolean;

    public constructor(private domSanitizer: DomSanitizer) {

    }

    public ngAfterViewInit(): void {

    }
}